export const isFieldVisible = (resource, metaFieldAfterExcludedUnless) => {
  // MetaControl does this anyway before rendering. Right now this is just another way to make a field hidden
  if (metaFieldAfterExcludedUnless.attr('readonly') && resource.attr(metaFieldAfterExcludedUnless.attr('name')) === undefined) {
    return false;
  }

  return !metaFieldAfterExcludedUnless.attr('hidden');
};
